import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import {
  AidaV2Config,
  BuyerConfigV2ApiResponse,
} from './buyer-config-settings-v2.interface';

@Injectable({
  providedIn: 'root',
})
export class BuyerConfigV2Service {
  private readonly _baseUrl = environment.pureSpectrum.url;

  constructor(private _http: HttpClient) {}

  getConfig(buyerId: number): Observable<BuyerConfigV2ApiResponse> {
    return this._http.get<BuyerConfigV2ApiResponse>(
      `${this._baseUrl}/config-settings/v2/buyers/${buyerId}`
    );
  }

  updateAidaV2(
    buyerId: number,
    aidaV2: AidaV2Config
  ): Observable<BuyerConfigV2ApiResponse> {
    return this._http.put<BuyerConfigV2ApiResponse>(
      `${this._baseUrl}/config-settings/v2/buyers/${buyerId}`,
      { aidaV2 }
    );
  }
}
